import React from "react";
import ReactDOM from "react-dom";
import { StyleRoot } from "radium";
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import AppService, {
  LocalStorageService,
  analytics,
  Utilities,
  AlertService
} from "s2s-app-service";
import reducer from "./reducers/index.js";
import {
  doReceiveAuthData,
  doConnected,
  doLoginFailure,
  doShowLogin,
  doLogOut,
  doExpiredPassword,
  doSetLanguage,
  doReconnect,
  doMakeCallError,
  doHungUp,
  doCallHeld,
  doConferenceData,
  doReceiveChat,
  doShowAlert,
  doDismissPersistent,
  doSetUITheme,
  doingMakeCall,
  doIncomingCall,
  doAppStatus,
  doMedia,
  doApiBroadcast,
  doHangUp,
  doAnswer,
  doMuteMic,
  doSaveAudioSettings,
  doOffline
} from "./action-creators/index.js";
// import Theme from 's2s-themes';
// import themes from './themes/theme-styles.js';
const isOnline = require("is-online");
import LoggingService from "s2s-logging-service";

import createBrowserHistory from "history/createBrowserHistory";
const appHistory = createBrowserHistory();
import { Router, Route } from "react-router-dom";
import Main from "./routes/main";

//import runtime from 'serviceworker-webpack-plugin/lib/runtime';

// accessiblity import
//import a11y from 'react-a11y'

// what is my environment
let myEnvironment = "prod"; // defaults to prod
if (location.href.indexOf("star2star.com") > -1) {
  myEnvironment = "prod";
} else if (location.href.indexOf("star2star.net") > -1) {
  myEnvironment = "test";
} else if (location.href.indexOf("localhost") > -1) {
  myEnvironment = "dev";
} else {
  //wtf
  LoggingService.getInstance().error(
    "something went wrong. You should never see this message"
  );
}

// ******************************
// ****      THE STORE       ****
// ******************************
const store = createStore(reducer, applyMiddleware(analytics, thunk));
const settings = store.getState().settings;
let appRingtone = settings.selectedRingTone;
let appExtension = settings.selectedExtension;
let appSpeaker = settings.selectedSpeaker ? settings.selectedSpeaker : {};
let appAudio = settings.selectedAudio ? settings.selectedAudio : {};
let appAlwaysOnTop = settings.alwaysontop;

// ******************************
// **** Internationalization ****
// ******************************
store.dispatch(doSetLanguage());

// ******************************
// ****   Theming Section    ****
// ******************************
store.dispatch(doSetUITheme());

// ******************************
// **** Store Subscriptions  ****
// ******************************
// First Register for window events
//online

const retryIsOnline = aEvent => {
  LoggingService.getInstance().info("retryIsOnline by: " + aEvent); //
  setTimeout(() => {
    if (navigator.onLine) {
      isOnline().then(online => {
        LoggingService.getInstance().debug("retryIsOnline", online); //
        //=> true
        if (online) {
          store.dispatch(doReconnect());
        } else {
          LoggingService.getInstance().debug(
            "retryIsOnline reported: ",
            online
          ); //
          retryIsOnline(aEvent + "-|");
        }
      });
    }
  }, 1000);
};

window.addEventListener(
  "online",
  () => {
    retryIsOnline("online");
  },
  false
);

window.addEventListener(
  "offline",
  () => {
    store.dispatch(doOffline());
  },
  false
);

// **********************************
// **** Headset Event Listeners  ****
// **********************************
document.addEventListener(
  "sleep",
  () => {
    store.dispatch(
      doAppStatus({ status: "offline", details: { call: "offline" } })
    );
  },
  false
);
document.addEventListener(
  "resume",
  () => {
    retryIsOnline("resuming");
  },
  false
);
document.addEventListener(
  "usbDevicesChanged",
  () => {
    LoggingService.getInstance().info("usbDevicesChanged event received");
    store.dispatch(doMedia());
  },
  false
);
document.addEventListener(
  "hangupAll",
  () => {
    const myLogger = LoggingService.getInstance();
    myLogger.info("hangupAll event received");
    const theStore = store.getState();
    if (theStore.callInfo.inprogressCalls) {
      Object.keys(theStore.callInfo.inprogressCalls).forEach(keyCallId => {
        myLogger.info("hangupAll - hanging up - " + keyCallId);
        store.dispatch(doHangUp(keyCallId));
      });
    }

    const checkAndWaitForNoCalls = () => {
      if (Object.keys(store.getState().callInfo.inprogressCalls).length > 0) {
        setTimeout(() => {
          checkAndWaitForNoCalls();
        }, 100);
      } else {
        // callback to container that all calls are disconnected
        if (typeof noCallsOKtoQuit == "function") {
          noCallsOKtoQuit();
        } else if (typeof window["noCallsOKtoQuit"] == "function") {
          window.noCallsOKtoQuit();
        } else {
          LoggingService.getInstance().info(
            "^^^^^^^^^^^ NO noCallsOKtoQuit ???"
          );
        }
      }
    };
    checkAndWaitForNoCalls();
  },
  false
);
document.addEventListener(
  "toggleAnswerHangup",
  () => {
    const theStore = store.getState();
    LoggingService.getInstance().debug("Toggle Answer Hangup");
    if (theStore.callInfo.activeCallId) {
      LoggingService.getInstance().debug("Toggle Hangup");
      store.dispatch(doHangUp(theStore.callInfo.activeCallId));
    } else if (Object.keys(theStore.callInfo.incomingCalls).length > 0) {
      LoggingService.getInstance().debug("Toggle Answer ");
      store.dispatch(doAnswer(Object.keys(theStore.callInfo.incomingCalls)[0]));
    }
  },
  false
);

document.addEventListener(
  "toggleMute",
  () => {
    const theStore = store.getState();
    LoggingService.getInstance().debug("MMMUUUTTTEEEE");
    if (theStore.callInfo && theStore.callInfo.activeCallId) {
      LoggingService.getInstance().debug("MUTE button");
      store.dispatch(doMuteMic(theStore.callInfo.activeCallId));
    }
  },
  false
);

document.addEventListener(
  "volumeUp",
  () => {
    const theStore = store.getState();
    const activeCall =
      theStore.callInfo &&
      theStore.callInfo.inprogressCalls &&
      theStore.callInfo.inprogressCalls[theStore.callInfo.activeCallId]
        ? theStore.callInfo.inprogressCalls[theStore.callInfo.activeCallId]
        : undefined;
    let audioSettings = {};
    if (activeCall != undefined) {
      // see if there are audioSettings already
      if (activeCall.audioSettings) {
        audioSettings.inputDevice = activeCall.audioSettings.inputDevice.label;
        audioSettings.outputDevice =
          activeCall.audioSettings.outputDevice.label;
        audioSettings.outputVolume =
          activeCall.audioSettings.outputVolume + 0.1;
        if (audioSettings.outputVolume > 0.9) {
          // use .9 because of weird floating point error
          audioSettings.outputVolume = 1;
        }
      } else {
        // no audio settings, so use the 'global' settings
        audioSettings.inputDevice = theStore.settings.selectedAudio.label;
        audioSettings.outputDevice = theStore.settings.selectedSpeaker.label;
        audioSettings.outputVolume = 1;
      }
      LoggingService.getInstance().info(
        "Volume UP button",
        audioSettings.outputVolume
      );
      store.dispatch(doSaveAudioSettings(audioSettings));
    }
  },
  false
);

document.addEventListener(
  "volumeDown",
  () => {
    const theStore = store.getState();
    const activeCall =
      theStore.callInfo &&
      theStore.callInfo.inprogressCalls &&
      theStore.callInfo.inprogressCalls[theStore.callInfo.activeCallId]
        ? theStore.callInfo.inprogressCalls[theStore.callInfo.activeCallId]
        : undefined;
    let audioSettings = {};
    if (activeCall != undefined) {
      // see if there are audioSettings already
      if (activeCall.audioSettings) {
        audioSettings.inputDevice = activeCall.audioSettings.inputDevice.label;
        audioSettings.outputDevice =
          activeCall.audioSettings.outputDevice.label;
        audioSettings.outputVolume =
          activeCall.audioSettings.outputVolume - 0.1;
        if (audioSettings.outputVolume < 0.1) {
          // use .1 because of weird floating point error
          audioSettings.outputVolume = 0;
        }
      } else {
        // no audio settings, so use the 'global' settings
        audioSettings.inputDevice = theStore.settings.selectedAudio.label;
        audioSettings.outputDevice = theStore.settings.selectedSpeaker.label;
        audioSettings.outputVolume = 0.9;
      }
      LoggingService.getInstance().info(
        "Volume DOWN button",
        audioSettings.outputVolume
      );
      store.dispatch(doSaveAudioSettings(audioSettings));
    }
  },
  false
);

//
store.subscribe(sData => {
  //const settings = store.getState().settings;
  const callInfo = store.getState().callInfo;

  // on store change check for app needs restarted... if we were on a call and
  // user changed settings, we would put off the restart until now...
  // if (store.getState().app.appRestartRequired && Utilities.allowRestart(callInfo)){
  //   appService.restart();
  // }
});

// ******************************
// **** AppServices Section  ****
// ******************************
const appService = AppService.getInstance()
  .addS2SService("api-user")
  .addS2SService("call")
  .addS2SService("xmpp")
  .setEnvironment(myEnvironment)
  .setAppApiKey("91156096-8f2e-4889-a6dd-a4a4bb3f4287", "Z73QvR18hnjmiFXMxdB6");
//const appService = AppService.getInstance(true, true).setEnvironment(isDev).setAppApiKey('9adcdcb7-5876-4839-90f4-a2d377d12da5', 'mJYBawiW7j2mxu0SFgVh');

const subId = appService.subscribe((event, status, data) => {
  LoggingService.getInstance().info(">>>> Subscription: ", event, status, data);
  switch (event) {
    case "app-status":
      store.dispatch(doAppStatus(data));
    case "xmpp_connected":
      break;
    case "connect":
      if (status === "error") {
        LoggingService.getInstance().info(">>>> sending doLoginFailure");
        store.dispatch(
          doLoginFailure(Utilities.sanitizeDataKeys(data), appHistory)
        );
      } else if (status === "expired") {
        store.dispatch(
          doExpiredPassword(Utilities.sanitizeDataKeys(data), appHistory)
        );
      } else {
        const authData = Utilities.sanitizeDataKeys(data);
        // save data to store via dispatch
        store.dispatch(doReceiveAuthData(authData, appHistory));
      }
      // login to Verto here
      break;
    case "s2sCallService-early":
      LoggingService.getInstance().debug(
        ">>>>> Early Recieved ... calling set audio"
      );
      store.dispatch(doSaveAudioSettings());
      break;
    case "s2sCallService-incoming-call":
      const {
        answered,
        attach,
        callID,
        cause,
        causeCode,
        direction,
        lastState,
        params,
        screenShare,
        state,
        useCamera,
        useMic,
        useSpeak
      } = data;
      const subsetIncomingData = {
        answered,
        attach,
        callID,
        cause,
        causeCode,
        direction,
        lastState,
        params,
        screenShare,
        state,
        useCamera,
        useMic,
        useSpeak
      };
      const incomingCall = Utilities.sanitizeDataKeys(subsetIncomingData);
      //window.incomingCall && window.incomingCall();
      // necessary for electron app only
      if (typeof incomingCall == "function") {
        incomingCall();
      } else if (typeof window["incomingCall"] == "function") {
        window.incomingCall();
      } else {
        LoggingService.getInstance().info("^^^^^^^^^^^ NO incomingCall ???");
      }
      store.dispatch(doIncomingCall(incomingCall));
      break;
    case "disconnect":
      break;
    case "myUserData":
      break;
    case "s2sCallService-loggedIn":
      LoggingService.getInstance().info(
        ">>>>>>logged in",
        event,
        status,
        appService.getStatus()
      );
      if (status === true) {
        store.dispatch(doConnected(appService.getStatus(), appHistory));
      } else {
        store.dispatch(
          doLoginFailure({
            message: "Fatal Error: Cannot Register with Server"
          })
        );
      }

      break;
    case "s2sCallService-logout":
      //refresh authData if older than 1 hour
      isOnline().then(online => {
        const authTS = store.getState().auth.timestamp;
        const refreshTS = Date.now() - 1000 * 60 * 60;
        const isRestarting = LocalStorageService.getData("restarting");
        if (!isRestarting && online === true && authTS < refreshTS) {
          LoggingService.getInstance().info(
            "issuing restart due to old auth data and server disconnected"
          );
          //store.dispatch(doReconnect()); // TODO Put back in
        } else {
          LoggingService.getInstance().info(
            "no restart since online is: " +
              online +
              " and auth was retrieved : " +
              (Date.now() - authTS) / (1000 * 60) +
              " minutes ago"
          );
        }
      });

      break;
    case "s2sCallService-failed-call":
      store.dispatch({
        type: "FAILED_CALL",
        payload: data,
        meta: {
          analytics: {
            category: "softphone",
            action: "failed-call"
          }
        }
      });
      break;
    case "s2sCallService-make-call":
      LoggingService.getInstance().info("<<<<<<<<", status);
      store.dispatch(
        doingMakeCall(
          status,
          data.number,
          data.callID,
          data.direction,
          data.timestamp,
          data.dialog,
          appHistory
        )
      );
      break;
    case "s2sCallService-makeCallError":
      LoggingService.getInstance().info("^^^^^", data);
      store.dispatch(doMakeCallError(data, appHistory));
      AlertService.getInstance().createErrorAlert(data.message);
      break;
    // case 's2sCallService-make-call-active':
    // case 'recovering':
    //   store.dispatch(doingMakeCall(status, (data.direction.name == 'outbound' ? data.params.destination_number : data.params.caller_id_number), data.callID, data.direction.name, appHistory));
    //   break;
    case "callHeld":
      store.dispatch(doCallHeld(data));
      break;
    case "chat-received":
      store.dispatch(doReceiveChat(data));
      break;
    case "conferenceData":
      store.dispatch(doConferenceData(data));
      break;
    case "s2sCallService-hangup":
      store.dispatch(doHungUp(data, appHistory));
      break;
    case "s2sCallService-mute":
      store.dispatch({
        type: "CALL_MUTED",
        payload: data,
        meta: {
          analytics: {
            category: "softphone",
            action: "muted"
          }
        }
      });
      break;
    case "s2sCallService-held":
      store.dispatch({
        type: "CALL_HELD",
        payload: data,
        meta: {
          analytics: {
            category: "softphone",
            action: "held"
          }
        }
      });
      break;
    case "showAlert":
      LoggingService.getInstance().info(">>>>>>>showAlert", data);
      AlertService.getInstance().createAlert(data);
      break;

    case "alerts-new":
      LoggingService.getInstance().info("Got to handler for alerts-new", data);
      store.dispatch(doShowAlert(data));
      break;

    //this is were I am adding things
    case "api_broadcast":
      //voicemail here
      store.dispatch(doApiBroadcast(data));
      break;
    case "dialPlanOptions":
      store.dispatch({
        type: "DIAL_PLAN_OPTIONS",
        payload: data
      });
      break;
    case "initial-voicemail":
      store.dispatch({
        type: "INITIAL_VOICEMAIL",
        payload: data,
        meta: {
          analytics: {
            category: "softphone",
            action: "voicemail"
          }
        }
      });
      break;
    default:
      LoggingService.getInstance().info(">>> Subscription Not Handled:", event);
  }
});

//const RenderedComponent = location.href.indexOf('update') > -1 ? Update : Main; //route is update

if (location.href.indexOf("update") === -1) {
  //route is update
  //only if not updating
  store.dispatch(doMedia());

  // fire default route
  store.dispatch(doShowLogin(appHistory));
}

//TODO remove
window.theStore = store;
window.appservice = appService;

LoggingService.getInstance().info("state", store.getState().app.showPage);

LoggingService.getInstance().info(
  "store.app.uiTheme.appliedTheme",
  store.getState().app.uiTheme.appliedTheme
);
ReactDOM.render(
  <Provider store={store}>
    <StyleRoot>
      <Router history={appHistory}>
        <Route path="/" component={Main} />
      </Router>
    </StyleRoot>
  </Provider>,
  document.getElementById("app")
);



// WEBPACK FOOTER //
// ./src/index.js